import { storage } from '@/common/storage'
import jwt_decode from 'jwt-decode'

export const auth = () => {
    const token = storage.getItem('access_token')
    if (!token) {
        return false
    }

    return Date.now() < storage.getItem('token_exp')
}

export const isLawyer = () => {
    return storage.getItem('role') === 'lawyer'
}

/**
 * Saves the authenticated user's session.
 *
 * @param {string} accessToken jwt access token
 */
export const logIn = (accessToken, role) => {
    let token = jwt_decode(accessToken)
    storage.setItem('access_token', accessToken)
    storage.setItem('token_exp', token.exp * 1000)
    storage.setItem('role', role)
}